import { PortalConsentResponse } from "../contracts/PortalConsentResponse";
import { PortalProfileResponse } from "../contracts/PortalProfileResponse";
import { PortalConsent, PortalProfile } from "../models/PortalProfile";

const FALLBACK_LANGUAGE = "en";

/** GET/PUT portal/members/{id}/profile → the Me model; absent optional fields read as null. */
export const toPortalProfile = (resp: PortalProfileResponse): PortalProfile => ({
  memberId: resp.memberId,
  firstName: resp.firstName,
  lastName: resp.lastName ?? "",
  email: resp.email ?? null,
  languageCode: resp.primaryLanguageCode || FALLBACK_LANGUAGE,
  isMinor: resp.isMinor ?? false,
  guardianFirstName: resp.guardianFirstName ?? null,
});

/** One consent; a withdrawn one is never offered for withdrawal, whatever the wire says. */
export const toPortalConsent = (resp: PortalConsentResponse): PortalConsent => ({
  id: resp.id,
  purpose: resp.purpose,
  documentVersion: resp.documentVersion,
  grantedAt: resp.grantedAt,
  withdrawnAt: resp.withdrawnAt ?? null,
  grantedByGuardian: resp.grantedByGuardian ?? false,
  withdrawable: (resp.withdrawable ?? false) && !resp.withdrawnAt,
});

export const toPortalConsents = (resp: PortalConsentResponse[] | null | undefined): PortalConsent[] =>
  (resp ?? []).map(toPortalConsent);
